import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { grey4 } from 'approot/shared/styles/colours.style';

export const DetailQuestionFooter = styled.div`
  border-top: 1px solid ${grey4};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: ${rem(spacing16)};
`;
